<template>
  <div class="feeInitializationList">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <div class="filters">
        <el-form :inline="true">
          <el-form-item>
            <el-select @change="selectUnit" v-model="form.houseId">
              <el-option key :label="$t('lang.lab_selectHouse')" value=""></el-option>
              <el-option v-for="(item,index) in houses" :key="index" :value="item.id" :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select @change="selectRoom" v-model="form.unitId">
              <el-option key :label="$t('lang.lab_selectUnit')" value=""></el-option>
              <el-option v-for="(item,index) in units" :key="index" :value="item.id" :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="form.roomId">
              <el-option key :label="$t('lang.lab_selectRoom')" value=""></el-option>
              <el-option v-for="(item,index) in rooms" :key="index" :value="item.id" :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 查询按钮 -->
          <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
          <el-button type="primary" @click="showImportData()">{{$t('lang.btn_downloadTemplate')}}</el-button>
          <!-- <el-upload class="upload-demo" ref="uploading" :on-remove="handleRemove" :on-change="handleSuccess"
            :on-error="uploadErr1" accept=".xlsx, .xls" action :file-list="fileList" :limit="1" :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
          </el-upload> -->
        </el-form>
      </div>
      <el-tab-pane label="房屋收款导入" name="homeFee">
        <el-card>
          <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
            :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
            <!-- checkbox -->
            <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
            <!-- 序号功能 -->
            <el-table-column type="index" :index="indexMethod" :label="$t('lang.lab_index')" align="center"
              width="100px"></el-table-column>
            <!-- 小区 -->
            <el-table-column prop="gardenName" :label="$t('lang.lab_village')"></el-table-column>
            <!-- 楼号 -->
            <el-table-column prop="houseName" :label="$t('lang.lab_buildingnum')"></el-table-column>
            <!-- 单元号 -->
            <el-table-column prop="unitName" :label="$t('lang.resourUnit')"></el-table-column>
            <!-- 房间号 -->
            <el-table-column prop="roomName" :label="$t('lang.lab_roomnum')"></el-table-column>
            <!-- 用户名 -->
            <el-table-column prop="ownerName" :label="$t('lang.lab_username')"></el-table-column>
            <!-- 手机 -->
            <el-table-column prop="mobile" :label="$t('lang.lab_phone')"></el-table-column>
            <el-table-column prop="feeName" :label="$t('lang.lab_feeName')"></el-table-column>
            <el-table-column prop="receivedAmount" :label="$t('lang.lab_balance')"></el-table-column>
            <!-- 操作 -->
            <el-table-column prop="operation" :label="$t('lang.lab_operation')"
              :width="require('@/config/enum').opr_width2">
              <template slot-scope="scope">
                <el-button class="orange" @click="deleteFee(scope.row)">{{$t('lang.btn_delete')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
            :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
            :page-count="pageCount" />
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="车位收款导入" name="carFee">
        <el-card>
          <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
            :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
            <!-- checkbox -->
            <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
            <!-- 序号功能 -->
            <el-table-column type="index" :index="indexMethod" :label="$t('lang.lab_index')" align="center"
              width="100px"></el-table-column>
            <!-- 小区 -->
            <el-table-column prop="gardenName" :label="$t('lang.lab_village')"></el-table-column>
            <!-- 楼号 -->
            <el-table-column prop="houseName" :label="$t('lang.lab_buildingnum')"></el-table-column>
            <!-- 单元号 -->
            <el-table-column prop="unitName" :label="$t('lang.resourUnit')"></el-table-column>
            <!-- 房间号 -->
            <el-table-column prop="roomName" :label="$t('lang.lab_roomnum')"></el-table-column>
            <!-- 用户名 -->
            <el-table-column prop="ownerName" :label="$t('lang.lab_username')"></el-table-column>
            <!-- 车位号 -->
            <el-table-column prop="placeName" :label="$t('lang.lab_placeName')"></el-table-column>
            <el-table-column prop="feeName" :label="$t('lang.lab_feeName')"></el-table-column>
            <el-table-column prop="receivedAmount" :label="$t('lang.lab_balance')"></el-table-column>
            <!-- 操作 -->
            <el-table-column prop="operation" :label="$t('lang.lab_operation')"
              :width="require('@/config/enum').opr_width2">
              <template slot-scope="scope">
                <el-button class="orange" @click="deleteFee(scope.row)">{{$t('lang.btn_delete')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
            :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
            :page-count="pageCount" />
        </el-card>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="费用导入" :visible.sync="importDataDialog" :close-on-click-modal="false" center top="5px !important"
      width="850px" @closed="handleDialogClosedImportData">
      <el-form :model="importForm" :rules="rules" ref="importForm" :label-width="require('@/config/enum').c_ws8"
        :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="detail.lab_fee_object" prop="locationTypeCd">
          <el-select class="select" v-model="importForm.objType"
            :placeholder="$t('lang.lab_please_Select')+detail.lab_locationTypeCd">
            <el-option key :label="$t('lang.lab_please_Select')+detail.lab_fee_object" value></el-option>
            <el-option :label="detail.lab_room" value="1212"></el-option>
            <el-option :label="$t('lang.lab_carPlace')" value="1515"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('lang.lab_feeTypeCdName')" prop="feeTypeCd">
          <el-select v-model="diaForm.feeTypeCd"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_feeTypeCdName')" class="select"
            @change="getFeeConfigList">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_feeTypeCdName')" value></el-option>
            <el-option v-for="item in feeTypeList" :key="item.status_cd" :label="item.name" :value="item.status_cd">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label=detail.lab_feeConfigName prop="configId">
          <el-select v-model="importForm.configName"
            :placeholder="$t('lang.lab_please_Select')+detail.lab_feeConfigName" class="select">
            <el-option key :label="$t('lang.lab_please_Select')+detail.lab_feeConfigName" value></el-option>
            <el-option v-for="item in feeConfigList" :key="item.configId" :label="item.feeName" :value="item.feeName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下载模板" prop="">
          请先下载
          <a href="javascript:void(0);" @click="excelDownLoad()">
            导入模板
          </a>
          准备数据后，上传导入
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearImportData">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // 引入富文本title汉字
  import {
    excelDownload
  } from '../../../config/download.js'
  /**
   *@ClassName:
   *@Description:期初导入列表
   *@author:xubz
   *@Copyright:格众科技
   */

  export default {
    name: '/manage/main.feeInitialization',
    data() {
      return {
        feeConfigList: [],
        feeTypeList: [],
        importForm: {
          objType: '',
          excelTemplate: ''
        },
        importDataDialog: false,
        activeName: 'homeFee',
        historyData: [],
        form: {
          houseId: '', // 楼号
          unitId: '', // 单元号
          roomId: '', // 房间号 
        },
        houses: [], //  存储根据小区请求回来的楼号
        units: [], //  存储根据楼号请求回来的单元
        rooms: [], //  存储根据单元请求回来的房间号
        fileList: [],

        gardenId: this.$store.getters.gardenId,
        pageCount: 0, // 总页数
        pageNo: 1, // 第几页
        pageSize: 10, // 每页显示数
        tableData: [], // 列表数组
        postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
        isDisabled: true, // 保存的可点击
        isPopupPage: false, // 弹框的显示控制
        multipleSelection: [], // 多选框
        detail: this.$i18n.t('lang.feePay'), //
        diaForm: {
          gardenId: '',
          house: 0,
          unit: 0,
          room: 0,
          type: 1,
          locationTypeCd: '',
          feeTypeCd: '',
          configId: ''
        },
        rules: {
          locationTypeCd: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.feePay.lab_locationTypeCd'),
            trigger: 'blur',
          }, ],
          feeTypeCd: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_feeTypeCdName'),
            trigger: 'blur',
          }, ],
          configId: [{
            required: true,
            message: this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.feePay.lab_feeConfigName'),
            trigger: 'blur',
          }, ],
        },
      }
    },
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.commit()
      }
    },
    created() {
      this.getTablelist()
      this.selectHouse(this.gardenId)
      this.getFeeDictList()
    },
    methods: {
      getFeeDictList() {
        let params = {
          tableName: 'pay_fee_config',
          tableColumns: 'fee_type_cd_show'
        }
        this.$get(`/feeDictList`, params).then(
          (res) => {
            if (res && res.errCode === 0) {
              this.feeTypeList = res.list
            }
          },
          (error) => {
            this.$message.error(error)
          }
        )
      },
      getFeeConfigList() {
        if (this.diaForm.feeTypeCd == '888800010009') {
          this.diaForm.locationTypeCd = '3000'
          this.locationTypeCdFlag = true
          this.diaForm.house = 0
          this.diaForm.unit = 0
          this.diaForm.room = 0
        } else {
          this.diaForm.locationTypeCd = ''
          this.diaForm.house = 0
          this.diaForm.unit = 0
          this.room = 0
          this.locationTypeCdFlag = false
        }
        let params = {
          gardenId: this.gardenId,
          feeTypeCd: this.diaForm.feeTypeCd
        }
        this.$get(`/feeConfigListByGardenId`, params).then(
          (res) => {
            this.diaForm.configId = ''
            if (res && res.errCode === 0) {
              this.feeConfigList = res.list
            }
          },
          (error) => {
            this.$message.error(error)
          }
        )
      },
      handleDialogClosedImportData() {
        var file = document.getElementById('excelTemplate');
        this.diaForm.feeTypeCd = ''
        this.importForm.configName = ''
        this.importForm.excelTemplate = ''
        this.importDataDialog = false
      },
      clearImportData() {
        var file = document.getElementById('excelTemplate');
        this.diaForm.feeTypeCd = ''
        this.importForm.configName = ''
        this.importForm.excelTemplate = ''
        this.importDataDialog = false
      },
      excelDownLoad() {
        if (this.importForm.objType == '' || this.importForm.objType == undefined) {
          this.$message.error('请选择费用对象')
          return
        }
        if (this.diaForm.feeTypeCd == '' || this.diaForm.feeTypeCd == undefined) {
          this.$message.error('请选择收费类型')
          return
        }
        if (this.importForm.configName == '' || this.importForm.configName == undefined) {
          this.$message.error('请选择收费项目')
          return
        }
        // if (this.diaForm.feeTypeCd == '888800010001' || this.diaForm.feeTypeCd == '888800010009') {

        // } else {
        //   this.$message.error('该导入功能只支持物业费和车位费导入')
        //   return
        // }
        if (this.diaForm.feeTypeCd != '888800010009' && this.importForm.objType != '1212') {
          this.$message.error('请正确选择收费类型')
          return
        }
        if (this.diaForm.feeTypeCd == '888800010009' && this.importForm.objType != '1515') {
          this.$message.error('请正确选择收费类型')
          return
        }
        var url = location.origin + '/mapi/feeExportData?gardenId=' + this.gardenId + '&objType=' + this.importForm
          .objType + '&configName=' + this.importForm.configName
        //  var url=location.origin+'/zhongljBack_maven/mapi/feeExportData?gardenId='+this.form.gardenId+'&objType='+this.importForm.objType+'&configName='+this.importForm.configName
        window.open(url)
      },
      showImportData(row) {
        this.importDataDialog = true
      },
      handleClick(tab, event) {
        this.activeName = tab._props.name
        this.getTablelist()
      },
      // id查询楼号楼层房间号
      gardenGrids(type, id) {
        if (id === '') return
        this.$get(`/gardenGrids/?type=${this.type}&parentId=${id}&pageNo=1&pageSize=9999`).then(
          res => {
            if (res && res.errCode === 0) {
              if (this.type === 1) {
                this.houses = res.list
              } else if (this.type === 2) {
                this.units = res.list
              } else if (this.type === 3) {
                this.rooms = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 根据小区选择获取楼号
      selectHouse(id) {
        this.type = 1
        this.form.houseId = ''
        this.form.unitId = ''
        this.form.roomId = ''
        this.houses = []
        this.units = []
        this.rooms = []
        this.gardenGrids(this.type, id)
      },
      // 根据楼号选择获取单元
      selectUnit(id) {
        this.type = 2
        this.form.unitId = ''
        this.form.roomId = ''
        this.units = []
        this.rooms = []
        this.gardenGrids(this.type, id)
      },
      // 根据单元选择获取房间
      selectRoom(id) {
        this.type = 3
        this.rooms = []
        this.form.roomId = ''
        this.gardenGrids(this.type, id)
      },

      // 下载模板
      download() {
        if (this.activeName == 'homeFee') {
          window.open(require('@/config/enum').mouldFeePrepaid)
        } else {
          window.open(require('@/config/enum').mouldFeeCarPrepaid)
        }

      },
      // 上传文件的断网
      uploadErr1() {
        if (!navigator.onLine || window.navigator.onLine === false) {
          const loading = this.$loading()
          setTimeout(() => {
            loading.close()
            this.$message.error(this.$i18n.t('lang.lab_Online'))
          }, 500)
        }
      },
      handleSuccess(e) {
        this.fileLists = e.raw
      },
      // 移除文件
      handleRemove() {
        this.fileList = []
        this.fileLists.length = 0
      },
      // 图片上传数量超过提醒
      outlimit() {
        this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
      },
      // 导入业主按钮
      submitUpload() {
        this.$confirm(this.$i18n.t('lang.lab_isExport'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            })
          .then(() => {
            if (this.fileLists.length < 1) {
              this.$message.warning(this.$i18n.t('lang.key_up_file'))
            } else {
              let formData = new FormData()
              formData.append('excelFile', this.fileLists)
              let loading = this.$loading()
              if (this.activeName == 'homeFee') {
                this.$postFormData(`/feeAdvanceReceiptImportData`, formData).then(
                  res => {
                    loading.close()
                    this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
                    this.fileList = []
                    this.commit()
                  },
                  error => {
                    loading.close()
                    this.$message.error(error)
                  }
                )
              } else {
                this.$postFormData(`/feeAdvanceReceiptCarImportData`, formData).then(
                  res => {
                    loading.close()
                    this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
                    this.fileList = []
                    this.commit()
                  },
                  error => {
                    loading.close()
                    this.$message.error(error)
                  }
                )
              }

            }
          })

      },
      // 列表隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 表格下载
      excelDownloadClick() {
        if (navigator.onLine) {
          // Excel表头
          const tHeader = [
            this.$i18n.t('lang.lbl_deviceManagement_name'),
            this.$i18n.t('lang.lbl_deviceManagement_deviceNo'),
            this.$i18n.t('lang.lbl_deviceManagement_param1'),
            this.$i18n.t('lang.lbl_deviceManagement_param2'),
            this.$i18n.t('lang.lbl_deviceManagement_param3'),
            this.$i18n.t('lang.lbl_deviceManagement_count'),
            this.$i18n.t('lang.lbl_deviceManagement_unit')
          ]
          // 对应table数据的列字段名
          const filterVal = ['name', 'deviceNo', 'param1', 'param2', 'param3', 'count', 'unit']
          excelDownload(tHeader, filterVal, this.tableData, this.$i18n.t('lang.lab_equipmentManagement'))
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      getTablelist() {
        let loading = this.$loading()
        let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          gardenId: this.form.gardenId,
          houseId: this.form.houseId,
          unitId: this.form.unitId,
          roomId: this.form.roomId,
          importType: '1',
          state: '1500',
          feeRoomOrCar: this.activeName,
          gardenId: this.gardenId
        }
        this.$get(`/payFeeDetailHistory/`, params).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getTablelist()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getTablelist()
      },
      commit() {
        this.pageNo = 1
        this.getTablelist()
      },
      deleteFee(row) {
        let loading = this.$loading()
        let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          feeId: row.feeId,
          state: '1400',
        }
        this.$get(`/payFeeDetailHistory/`, params).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              // if (res.list.length > 0) {
              //   this.$message.error('存在缴费信息无法删除')
              //   return
              // } else {
                this.$confirm(this.$i18n.t('lang.lab_isdelete'),
                    this.$i18n.t('lang.lab_prompt'), {
                      confirmButtonText: this.$i18n.t('lang.btn_confirm'),
                      cancelButtonText: this.$i18n.t('lang.btn_cancel'),
                      type: 'warning'
                    })
                  .then(() => {
                    row['feeState'] = '1'
                    this.$postJson(`/delFeePayHistoryByIdImport/`, row).then(
                      res => {
                        loading.close()
                        if (res && res.errCode === 0) {
                          this.$message.success(this.$i18n.t('lang.lab_del_success'))
                          this.getTablelist()
                        }
                      },
                      error => {
                        loading.close()
                        this.$message.error(error)
                      }
                    )
                  })
                  .catch(() => {
                    loading.close()
                    this.$message({
                      type: 'info',
                      message: this.$i18n.t('lang.lab_del_can')
                    })
                  })
              // }

            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )




      },
      getPayHistorylist(id) {
        let loading = this.$loading()
        let params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          feeId: id,
          state: '1400',
        }
        this.$get(`/payFeeDetailHistory/`, params).then(
          (res) => {
            loading.close()
            if (res && res.errCode === 0) {
              this.historyData = res.list
            }
          },
          (error) => {
            loading.close()
            this.$message.error(error)
          }
        )
      }
    }
  }
</script>

<style lang="scss">
  .el-tooltip__popper.is-light {
    max-width: 300px;
  }

  .feeInitializationList .upload-demo {
    display: inline;
    padding-left: 20px;
  }

  .el-tabs__nav-wrap {
    width: 100% !important;
    max-width: 100% !important;
    background-color: #fff !important;
    box-sizing: border-box;
  }

  .el-tabs__content {
    margin-top: 2.5% !important;
  }
</style>